/***
*
*   usePermissions hook
*   fetch, format and return the user permissions
*
**********/

import { useState, useEffect } from 'react';
import { useAPI } from 'components/lib';

export function usePermissions(firm){

  const [state, setState] = useState({ data: null, loading: false });
  const permissions = useAPI('/api/user/permissions');

  useEffect(() => {

    setState({ loading: true });

    // format permissions
    if (permissions.data){

      let perms = [];
      Object.keys(permissions?.data).forEach(perm => {
        // filter out the firm permissions
        if(!firm && perm !== 'client') return;
        if(firm && perm === 'client') return;

        perms.push({ value: perm, label: perm.charAt(0).toUpperCase() + perm.slice(1) });
        setState({ data: { list: perms }, loading: false });

      });
    }
  }, [permissions, firm]);

  return state;

}
